import { render, staticRenderFns } from "./LinkedContentDialog.vue?vue&type=template&id=21630b9a&scoped=true"
import script from "./LinkedContentDialog.vue?vue&type=script&lang=js"
export * from "./LinkedContentDialog.vue?vue&type=script&lang=js"
import style0 from "./LinkedContentDialog.vue?vue&type=style&index=0&id=21630b9a&prod&lang=sass&scoped=true"
import style1 from "./LinkedContentDialog.vue?vue&type=style&index=1&id=21630b9a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21630b9a",
  null
  
)

export default component.exports